import { BaseService } from "./base";
import { Alert } from "../models/alert";
import type { AlertCounts } from "../types/interfaces/alert";

import { ApiRequest } from "../lib/request";
import { ApiResponse, ApiListResponse } from "../lib/response";

export class AlertService extends BaseService<Alert> {
  override model = Alert;
  override modelName = 'alert';
  override modelLabel = 'Alert';

  async filtered({ 
    page = 1, 
    filter = null 
  }: { 
    page?: number; 
    filter?: string | null; 
  } = {}): Promise<ApiListResponse<Alert>> {
    let url = this.modelBaseUrl + '/?page=' + page;

    if (filter) {
      url += `&filter=${filter}`;
    }

    const request = new ApiRequest({
      method: 'GET',
      url,
    });

    return await this.requestList<Alert>(request, this.model);
  }

  async counts(): Promise<ApiResponse<AlertCounts>> {
    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl + '/counts',
    });

    return await this.requestItem<AlertCounts>(request, Object as any);
  }

  async markRead(alert: Alert): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${alert.objectID()}/markRead`,
    });

    return await this.requestItem<any>(request, Object as any);
  }

  async markAllRead(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl + '/markAllRead',
    });

    return await this.requestItem<any>(request, Object as any);
  }

  async bulkDelete(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl + '/bulkDelete',
    });

    return await this.requestItem<any>(request, Object as any);
  }
} 